import { withAfterpayPaymentMethodProps } from 'viewModel/afterpay/afterpayPaymentMethod/withAfterpayPaymentMethodProps';

import AfterpayPaymentMethod from 'components/Afterpay/AfterpayPaymentMethod/AfterpayPaymentMethod';

export default withAfterpayPaymentMethodProps(AfterpayPaymentMethod);
